module.exports = __webpack_public_path__ + "img/Sad_Bird@2x.482dc5eb.png";